// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const DispatchResetSearchFields: Handler = props => {
    props.dispatch({
        type: "Store/Components/FastenersTable/ResetSearchFields",
    });
};

export const chain = [DispatchResetSearchFields];

const resetSearchFields = createHandlerChainRunnerOptionalParameter(chain, {}, "ResetSearchFields");
export default resetSearchFields;
